import { SectionGate } from "@/features/dossier-details";
import { Badge, Checkbox, Icon, Label } from "@/shared/components";
import { convertToKebabCase } from "@/shared/utils";
import { Link } from "react-router";
import { OpenstaandOnderdeel } from "./openstaande-onderdelen.utils";

type OpenstaandeOnderdelenProps = {
    openstaandeOnderdelen: OpenstaandOnderdeel[];
    heeftKHRStatus: boolean;
    onHeeftKHRStatusChange: (value: boolean) => void;
};

export function OpenstaandeOnderdelen({ openstaandeOnderdelen, heeftKHRStatus, onHeeftKHRStatusChange }: OpenstaandeOnderdelenProps) {
    return (
        <ul className="text-content-emphasis px-4" data-testid="openstaande-onderdelen">
            {openstaandeOnderdelen.map((item) => {
                return item.type === "evaluatie" ? (
                    <SectionGate section={item.section}>
                        <li
                            key={item.type}
                            className="grid gap-1 pt-4"
                            data-testid={`openstaand-onderdeel-${convertToKebabCase(item.section)}`}
                        >
                            <OpenstaandOnderdeelEvaluatieItem
                                item={item}
                                heeftKHRStatus={heeftKHRStatus}
                                onHeeftKHRStatusChange={onHeeftKHRStatusChange}
                            />
                        </li>
                    </SectionGate>
                ) : (
                    <SectionGate section={item.section}>
                        <li
                            className="border-b py-4 first:pt-0"
                            key={item.type}
                            data-testid={`openstaand-onderdeel-${convertToKebabCase(item.section)}`}
                        >
                            <OpenstaandOnderdeelItem item={item} />
                        </li>
                    </SectionGate>
                );
            })}
        </ul>
    );
}

type OpenstaandOnderdeelItemProps = {
    item: OpenstaandOnderdeel;
};

function OpenstaandOnderdeelItem({ item }: OpenstaandOnderdeelItemProps) {
    return (
        <Link to={item.url} className="flex justify-between">
            <span className="font-medium">{item.label}</span>
            <div className="flex items-center gap-3">
                <Badge variant={item.badge.variant}>{item.badge.text}</Badge>
                <Icon name="chevron-right" className="text-content-interactive-default" />
            </div>
        </Link>
    );
}

type OpenstaandOnderdeelEvaluatieItemProps = OpenstaandOnderdeelItemProps & {
    heeftKHRStatus: boolean;
    onHeeftKHRStatusChange: (value: boolean) => void;
};

function OpenstaandOnderdeelEvaluatieItem({ item, heeftKHRStatus, onHeeftKHRStatusChange }: OpenstaandOnderdeelEvaluatieItemProps) {
    return (
        <>
            <OpenstaandOnderdeelItem item={item} />
            <div className="grid grid-cols-[auto_1fr] items-center gap-x-2">
                <Checkbox id="khr" checked={heeftKHRStatus} onCheckedChange={(checked) => onHeeftKHRStatusChange(checked === true)} />
                <Label className="text-content-default cursor-pointer font-normal" htmlFor="khr">
                    KHR status
                </Label>
                <p className="text-s text-content-subtle col-start-2">
                    De KHR-status wordt bereikt bij het opheffen van 5 of meer treinen op een route.
                </p>
            </div>
        </>
    );
}
